<template>
  <div class="pixel-second-step">
    <checkboxes-dropdown
      v-model="innerValue"
      masculine
      label="Quais eventos você deseja receber?"
      :options="options"
      :all-button="false"
      @change="value => $emit('update', value)"
    />

    <advanced-settings :form="form" :errors="errors" class="mt-6" />
  </div>
</template>
<script>
import AdvancedSettings from "./AdvancedSettings.vue";
export default {
  components: { AdvancedSettings },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      innerValue: ["track_initiate_checkout", "track_purchase"].filter(
        opt => this.form[opt]
      ),
      options: [
        {
          id: "track_initiate_checkout",
          name: "Visitas no checkout",
          description:
            "Ao ativar, você saberá quantas pessoas visitaram a sua página de pagamentos."
        },
        {
          id: "track_purchase",
          name: "Conversão de vendas",
          description:
            "Ao ativar, você saberá quantas pessoas chegaram até a página de obrigado."
        }
      ]
    };
  }
};
</script>
